import { ContainerTI, Card, Quantity } from './styles';
import { Props } from './types';
import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import { loadRequest } from '../../../../../../store/ducks/kpiEAE/actions';
import React from 'react';
import DetalhesOcorrencia from '../../modalDetalhesOcorrencia';

const CardEA: React.FC<Props> = ({ cdd, inscricao }) => {
  const dispatch = useDispatch();
  const loading = useSelector((state: ApplicationState) => state?.KPIEAE?.loading);
  const data = useSelector((state: ApplicationState) => state?.KPIEAE?.data[0]);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  React.useEffect(() => {
    dispatch(loadRequest(cdd, inscricao, 'EAE', 1));
  }, [cdd, dispatch, inscricao]);

  return (
    <Card key={data?.card} className="themeSLA">
      <DetalhesOcorrencia
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        protocolos={data?.protocolos}
      />
      <ContainerTI className="containerTI">
        <div className="ti">
          <h2 className="title">Atendimentos em aberto</h2>
          <span className="info">
            <Tooltip title="Todos os atendimentos que se encontram a espera de uma resposta do parceiro">
              <InfoCircleOutlined role="tooltip" style={{ cursor: 'pointer' }} />
            </Tooltip>
          </span>
        </div>
        <Quantity onClick={() => setIsModalOpen(true)}>
          <p>{!loading ? data?.total?.toString()?.padStart(2, '0') : <LoadingOutlined />}</p>
          <p>
            {!loading ? (
              data?.percentual && data?.percentual?.toString()?.padStart(2, '0') + '%'
            ) : (
              <LoadingOutlined />
            )}
          </p>
        </Quantity>
      </ContainerTI>

      <h4 className="themeDashboard">{data?.card}</h4>

      <h4
        className="themeDashboard"
        style={{
          width: '100%',
          marginTop: '20px 0',
          fontWeight: 'bold',
          background: '#F8F8F8',
          padding: '5px',
          textAlign: 'center',
        }}
      >
        Todo o período
      </h4>
    </Card>
  );
};

export default CardEA;
